// extracted by mini-css-extract-plugin
module.exports = {"bgImage":"App_bgImage__w2iRz","content":"App_content__22rHW"};